import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProfileOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Layout, Popover, Tag, theme, Typography } from "antd";
import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { BusAdminActions } from "../../../redux/Slices/BusAdmin/BusAdmin.slice";
import { logout } from "../../../utils/utility";
import LogComponent from "../../Log";
import { useAppDispatch, useTypedSelector } from "../../../redux/redux-hooks";
import { AppDispatch, RootState } from "../../../redux/Store";
import { useAuth } from "../../../context/auth-context";

const { Header } = Layout;

const HeaderComponent: FC<{
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ collapsed, setCollapsed }) => {
  // HOOKS
  const dispatch: AppDispatch = useAppDispatch();
  const busAdminState = useTypedSelector(
    (state: RootState) => state.bus_admin.busAdmin
  );
  const navigate = useNavigate();
  const { hasPermission, hasFeature } = useAuth();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const onLogout = () => {
    logout();

    dispatch(BusAdminActions.resetLogin());
    navigate(ROUTES.LOGIN);
  };

  const onProfileClick = () => {
    navigate(ROUTES.PROFILE);
  };

  const SettingContent = () => {
    return (
      <div className="d-flex flex-column align-items-start hidden-print">
        <Button type="text" icon={<ProfileOutlined />} onClick={onProfileClick}>
          Profile
        </Button>

        <Button type="text" icon={<LogoutOutlined />} onClick={onLogout}>
          Log Out
        </Button>
      </div>
    );
  };

  return (
    <Header
      style={{
        padding: 0,
        background: colorBgContainer,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
      className="hidden-print"
    >
      <div>
        {collapsed ? (
          <MenuUnfoldOutlined
            className={"nav-collapse-trigger hidden-print"}
            onClick={() => setCollapsed(!collapsed)}
          />
        ) : (
          <MenuFoldOutlined
            className={"nav-collapse-trigger hidden-print"}
            onClick={() => setCollapsed(!collapsed)}
          />
        )}

        <Typography.Text className="welcome-text">
          Hi, Welcome back!
        </Typography.Text>
      </div>
      <div className="d-flex">
        <span
          style={{
            color: "white",
          }}
        >
          {busAdminState.payload?.firstName} {busAdminState.payload?.lastName}
        </span>
        <Popover
          content={<SettingContent />}
          title={<Tag color="cyan-inverse">Settings</Tag>}
          placement="bottomRight"
        >
          <UserOutlined
            className={"hidden-print"}
            style={{ padding: "0 0 0 10px" }}
          />
        </Popover>
        {hasFeature("log") && hasPermission("log", "log:view-paged") && (
          <div style={{ marginRight: "10px", padding: "0 10px 0 10px" }}>
            <LogComponent />
          </div>
        )}
      </div>
    </Header>
  );
};

export default HeaderComponent;
